(function () {
    "use strict";

    angular.module("app").factory("actionbarService", actionBarService);

    actionBarService.$inject = ["$rootScope", "HABIL_EVENTS"];
    function actionBarService($rootScope, HABIL_EVENTS) {

        const registeredListeners = {};

        function register(event, callback) {
            registeredListeners[event] = callback;
        }

        function broadcast(event, ...args) {
            $rootScope.$broadcast(event, ...args);
        }

        function broadcastEvent(event, ...args) {
            if (registeredListeners[event]) {
                registeredListeners[event](...args);
            }

            broadcast(event, ...args);
        }

        return {
            Register: register,
            Broadcast: broadcast,
            nextClick: () => broadcastEvent(HABIL_EVENTS.navigation.nextTab),
            saveClick: jqEvent => broadcastEvent(HABIL_EVENTS.actionBar.save, jqEvent),
            previousClick: () => broadcastEvent(HABIL_EVENTS.navigation.previousTab),
            closeClick: () => broadcastEvent(HABIL_EVENTS.actionBar.close),
            acceptedClick: () => broadcastEvent("actionBar_acceptedClick"),
            returnClick: () => broadcastEvent("actionBar_returnClick"),
            extractClick: () => broadcastEvent("actionBar_extractClick"),
            toStatus: () => broadcastEvent("actionBar_toStatus"),
            AddResultClick: () => broadcastEvent("actionBar_addResultClick")
        };
    }
})();
